// class on body determines if we show "support us" banners
if (isPremium) {document.body.classList.add('isp')}

function loadTwitterWidgets(root = document) {
  if (window.twttr && window.twttr.ready) {
    window.twttr.ready(() => {
      if (window.twttr.widgets && typeof window.twttr.widgets.load == 'function') {
        window.twttr.widgets.load(root)
      }
    })
  }
}

document.addEventListener('turbolinks:load', () => loadTwitterWidgets())
